<template>
    <div
        class="scc-column scc-container__column scc-container__column--12"
        :class="[`scc-container__lg-column--${columns}`]"
    >
        <slot />
    </div>
</template>

<script>
import './column.scss';

export default {
    name: 'Column',
    props: {
        columns: {
            type: Number,
            default: 12,
        },
    },
};
</script>
